import { render, staticRenderFns } from "./branchAccountView.vue?vue&type=template&id=8c5f8dc0&"
import script from "./branchAccountView.vue?vue&type=script&lang=js&"
export * from "./branchAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports